import PaymentsForContactDatagrid from 'src/components/DatagridEntity/PaymentsForContactDatagrid';

const PaymentsContactPage = () => (<PaymentsForContactDatagrid />);
export default PaymentsContactPage;
